<template>
  <div v-if="!loadingPage">
    <TabsProjeto
      :idProjeto="id"
      :permiteAlterar="permiteAlterar"
      :qtdeAtividades="projetoAtividades.length"
      :qtdeProjetos="projetoProjetos.length"
      :loading="loadingProjeto"
      :showInfoColumn="showInfoColumn"
      @close="close"
      @save="save"
      @searchAtividade="searchAtividade"
      @refreshAtividadesProjeto="refreshAtividadesProjeto"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
      @finalizaItemSelected="finalizaItemSelected"
      @voltaStatusItemSelected="voltaStatusItemSelected"
      @abreModalEditPrevisao="abreModalEditPrevisao"
      @abreModalEditSituacao="abreModalEditSituacao"
      @abreModalEditResponsavel="abreModalEditResponsavel"
      @abreModalEditColaborador="abreModalEditColaborador"
      @abreModalEditCliente="abreModalEditCliente"
      @abreModalEditTag="abreModalEditTag"
      @abreModalListAtividade="abreModalListAtividade"
      @abreModalEditTipoAtividade="abreModalEditTipoAtividade"
      @abreModalSetaOcorrencia="abreModalSetaOcorrencia"
      @abreModalEditWorkflow="abreModalEditWorkflow"
      @removerVinculoAtividade="removerVinculoAtividade"
      @showInfoColumn="showInfoColumn = !showInfoColumn"
      @filtraAtividades="filtraAtividades"
    >
      <v-container fluid px-3 slot="dados">
        <v-layout wrap>
          <v-flex xs12 :md9="showInfoColumn">
            <v-card>
              <v-card-text wrap class="projeto-detalhes">
                <div v-if="projeto.DataEmissao" class="projeto-detalhes-item mr-2 mb-1">
                  <h6 class="projeto-detalhes-item-header subheading">Emissão</h6>
                  <v-chip color="default">
                    <v-avatar class="mr-0">
                      <v-icon small>event</v-icon>
                    </v-avatar>
                    {{ moment(projeto.DataEmissao).format('DD [de] MMM [de] YYYY') }}
                  </v-chip>
                </div>
                <div v-if="projeto.DataPrevisao" class="projeto-detalhes-item mr-2 mb-1">
                  <h6 class="projeto-detalhes-item-header subheading">Previsão</h6>
                  <v-chip color="warning" text-color="white">
                    <v-avatar class="mr-0">
                      <v-icon small>event</v-icon>
                    </v-avatar>
                    {{ moment(projeto.DataPrevisao).format('DD [de] MMM [de] YYYY') }}
                  </v-chip>
                </div>
                <div v-if="projeto.DataFinalizacao" class="projeto-detalhes-item mr-2 mb-1">
                  <h6 class="projeto-detalhes-item-header subheading">Finalização</h6>
                  <v-chip color="success" text-color="white">
                    <v-avatar class="mr-0">
                      <v-icon small>event</v-icon>
                    </v-avatar>
                    {{ moment(projeto.DataFinalizacao).format('DD [de] MMM [de] YYYY') }}
                  </v-chip>
                </div>
                <div v-if="projeto.Situacao" class="projeto-detalhes-item mr-2 mb-1">
                  <h6 class="projeto-detalhes-item-header subheading">Situação</h6>
                  <v-chip :color="projeto.Cor" text-color="white">
                    <v-avatar class="mr-0">
                      <v-icon small>description</v-icon>
                    </v-avatar>
                    {{ projeto.Situacao }}
                  </v-chip>
                </div>
                <div v-if="projeto.Status" class="projeto-detalhes-item mr-2 mb-1">
                  <h6 class="projeto-detalhes-item-header subheading">Status</h6>
                  <v-avatar class="mt-1" size="32" :color="statusProjeto(projeto.Status)">
                    <span class="white--text">{{ projeto.Status[0] }}</span>
                  </v-avatar>
                </div>
                <div v-if="projetoColaboradores.length" class="projeto-detalhes-item interessados mr-2">
                  <h6 class="projeto-detalhes-item-header subheading">Colaboradores</h6>
                  <v-chip
                    :disabled="!permiteAlterar"
                    @input="excluiColaborador(colaborador)" 
                    close v-for="colaborador in projetoColaboradores" :key="colaborador.IdColaborador">
                    <v-avatar class="primary white--text">{{ colaborador.Colaborador[0] }}</v-avatar>
                    {{ colaborador.Colaborador }}
                  </v-chip>
                </div>
                <!-- <div v-if="projetoClientes.length" class="projeto-detalhes-item interessados mr-2">
                  <h6 class="projeto-detalhes-item-header subheading">Clientes</h6>
                  <v-chip 
                    @click.stop="infoClient(cliente)"
                    @input="excluiCliente(cliente)" 
                    close 
                    v-for="(cliente, index) in projetoClientes" :key="index">
                    <v-avatar class="primary white--text">{{ cliente.Fantasia[0] }}</v-avatar>
                    {{ cliente.Fantasia }}
                  </v-chip>
                </div> -->
                <div v-if="projeto.IdCliente" class="projeto-detalhes-item interessados mr-2">
                  <h6 class="projeto-detalhes-item-header subheading">Cliente</h6>
                  <v-chip @click.stop="infoClient(projeto.IdCliente)">
                    <v-avatar class="primary white--text">{{ projeto.Fantasia[0] }}</v-avatar>
                    {{ projeto.Fantasia }}
                  </v-chip>
                </div>
                <div v-if="projetoTags.length" class="projeto-detalhes-item interessados mr-2">
                  <h6 class="projeto-detalhes-item-header subheading">Tags</h6>
                  <v-chip 
                    :disabled="!permiteAlterar"
                    @input="excluiTag(tag)"
                    close v-for="tag in projetoTags" :key="tag.IdTag">
                    {{ tag.Descricao }}
                  </v-chip>
                </div>
                <div v-if="projeto.ValorGut" class="projeto-detalhes-item interessados mr-2">
                  <h6 class="projeto-detalhes-item-header subheading">GUT</h6>
                  <v-progress-circular
                    :size="36"
                    :value="projeto.ValorGut || 0"
                    :color="matrizGutColor(projeto.ValorGut || 0)"
                  >
                    <span class="font-weight-medium">{{ projeto.ValorGut || 0 }}</span>
                  </v-progress-circular>
                </div>
                <div v-if="projeto.ValorNps !== null && projeto.ValorNps !== undefined" class="projeto-detalhes-item interessados mr-2">
                  <h6 class="projeto-detalhes-item-header subheading">NPS</h6>
                  <v-progress-circular
                    :size="36"
                    :value="npsValue(projeto.ValorNps)"
                    :color="npsColor(projeto.ValorNps)"
                  >
                    <span class="font-weight-medium">{{ projeto.ValorNps }}</span>
                  </v-progress-circular>
                </div>
              </v-card-text>
            </v-card>
            <v-card class="my-3">
              <v-card-text class="pb-0">
                <v-form
                  v-model="valid"
                  ref="formProjeto"
                  @submit.prevent="save"
                >
                  <v-text-field
                    :disabled="!permiteAlterar"
                    :value="projeto.Projeto"
                    @change="v => projeto.Projeto = v"
                    label="Descrição"
                    :rules="[rules.required]"
                    required
                    outline
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-card>
            <v-card>
              <v-toolbar dense card class="tb">
                <v-toolbar-title>Grupos e Atividades</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom v-if="!inputItemProjeto && permiteAlterar">
                  <v-btn
                    icon
                    color="primary"
                    @click="mostraInputItemProjeto"
                    slot="activator"
                    class="elevation-5"
                  ><v-icon dark>add</v-icon>
                  </v-btn>
                  <span>Adicionar</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text class="itens-projeto cardscroll pt-0" v-if="!vinculaItemLoading">
                <div class="itemProjeto">
                  <div class="itemProjeto-body" :class="inputActive">
                    <v-flex xs12 v-for="(itemProjeto, index) in itensProjetoOrdenado" :key="index">
                      <v-layout @dblclick="editaItemDblClick(itemProjeto)" py-1 row wrap align-center v-if="editandoItemProjeto !== itemProjeto.IdItem">
                        <v-flex xs4 class="align-content-center">
                          <!-- <v-icon 
                            v-if="itemProjeto.Atividade && itemProjeto.Atividade.Status == 'F   '" 
                            color="success" 
                            class="mr-1"
                          >
                            check_circle
                          </v-icon> -->
                          <span 
                            :class="itemProjeto.IdTipo == 1 ? 'font-weight-bold' : ''"
                          >
                            {{ itemProjeto.Classificacao }} - {{ itemProjeto.Item }}
                          </span>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 v-if="itemProjeto.IdTipo == 2" class="align-content-center">
                          <v-icon class="mr-1" v-if="itemProjeto.DuracaoPrevista">access_time</v-icon>
                          <span v-if="itemProjeto.DuracaoPrevista">
                            {{ duracaoItem(itemProjeto.DuracaoPrevista) }} <span v-if="$vuetify.breakpoint.xlAndUp">/</span>
                            <span 
                              v-if="itemProjeto.Atividade"
                              :class="corDuracaoItemProjeto(itemProjeto.DuracaoPrevista, itemProjeto.Atividade.Duracao)"
                            >
                              {{ duracaoItem(itemProjeto.Atividade.Duracao) }}
                            </span>
                          </span>
                        </v-flex>
                        <v-flex xs2 class="align-content-center">
                          <v-icon class="mr-1">date_range</v-icon>
                          <span :class="itemProjeto.IdTipo == 1 ? 'font-weight-bold' : ''">
                            {{ moment(itemProjeto.PrevisaoInicial).format('DD [-]') }}
                            {{ moment(itemProjeto.PrevisaoFinal).format('DD MMM YY') }}
                          </span>
                        </v-flex>
                        <v-flex xs4 v-if="itemProjeto.IdTipo == 2 && itemProjeto.Atividade">
                          <v-chip 
                            :color="itemProjeto.Atividade.Cor"
                            dark
                          >
                            {{ itemProjeto.Atividade.Situacao }}
                          </v-chip>
                          <v-icon class="mr-1">person</v-icon>
                          <span>
                            {{ itemProjeto.Atividade.Responsavel }}
                          </span>
                          <span class="pl-1 font-italic">
                            ({{ moment.utc(itemProjeto.Atividade.DataPrevisao).format('DD MMM YY') }})
                          </span>
                        </v-flex>
                        <v-flex xs4 v-if="itemProjeto.IdTipo == 2 && itemProjeto.Projeto">
                          <v-chip 
                            :color="itemProjeto.Projeto.Cor"
                            dark
                          >
                            {{ itemProjeto.Projeto.Situacao }}
                          </v-chip>
                          <v-icon class="mr-1">person</v-icon>
                          <span>
                            {{ itemProjeto.Projeto.Responsavel }}
                          </span>
                          <span class="pl-1 font-italic">
                            ({{ moment.utc(itemProjeto.Projeto.DataPrevisao).format('DD MMM YY') }})
                          </span>
                        </v-flex>
                        <v-menu
                          v-if="permiteAlterar"
                          :close-on-content-click="false"
                          bottom
                          left
                        >
                        <template v-slot:activator="{ on }">
                          <v-btn flat icon small v-on="on">
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>
                          <v-list>
                            <v-list-group
                              v-if="!itemProjeto.Atividade && !itemProjeto.Projeto"
                              v-model="menuAdicionarItem"
                              prepend-icon="search"
                              no-action                                          
                            >
                              <template v-slot:activator>
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-list-tile-title>Adicionar Item</v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </template>
                              <v-list-tile
                                v-if="!itemProjeto.Atividade && !itemProjeto.Projeto"
                                @click="abreModalListAtividade(itemProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Atividade
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>add</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile
                                v-if="!itemProjeto.Projeto"
                                @click="abreModalListProjeto(itemProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Projeto
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>add</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile
                                v-if="itemProjeto.IdTipo == 1"
                                @click="abreModalListClientes(itemProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Clientes
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>add</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                            </v-list-group>
                            <v-list-group
                              v-model="menuAcoes"
                              prepend-icon="settings"
                              no-action                                          
                            >
                              <template v-slot:activator>
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-list-tile-title>Ações</v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </template>
                              <v-list-tile
                                v-if="itemProjeto.IdTipo == 2 && !itemProjeto.Atividade && !itemProjeto.Projeto"
                                @click="abreModalIniciaAtividade(itemProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Iniciar Atividade
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>add</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile
                                v-if="itemProjeto.IdTipo == 2 && itemProjeto.Atividade"
                                @click="$router.push({ name: 'altera atividade', params: { id: itemProjeto.Atividade.IdAtividade } })"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Alterar Atividade
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>launch</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile
                                v-if="itemProjeto.IdTipo == 2 && itemProjeto.Projeto"
                                @click="abreModalInfoProjeto(itemProjeto.Projeto.IdProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Ver Projeto
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>visibility</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile
                                @click="editaItemProjeto(itemProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Alterar Item
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>edit</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile
                                @click="abreModalItemProjetoPreferencias(itemProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Preferências
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>settings</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile
                                @click="excluiItemProjeto(itemProjeto)"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    Excluir
                                  </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon>delete</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                            </v-list-group>
                          </v-list>
                        </v-menu>
                      </v-layout>
                      <v-divider :color="itemProjeto.IdTipo == 1 ? 'gray' : ''"></v-divider>
                      <!-- Input Edita Item Projeto -->
                      <v-layout row wrap v-if="editandoItemProjeto == itemProjeto.IdItem">
                        <v-flex xs12 class="border-form">
                          <v-layout row wrap align-center>
                            <v-flex xs2>
                              <v-text-field 
                                label="Classificação"
                                :value="classificacaoItemProjeto"
                                @change="v => classificacaoItemProjeto = v"
                                prepend-icon="folder"
                                id="itemProjeto-edit-item"
                                @keyup.esc="cancelaEditaItemProjeto(itemProjeto)" 
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2>
                              <v-autocomplete
                                v-model="editItemProjeto.Tipo"
                                :items="[{ IdTipo: 1, Descricao: 'GRUPO'}, { IdTipo: 2, Descricao: 'ITEM'} ]"
                                item-text="Descricao"
                                return-object
                                menu-props="auto"
                                label="Tipo"
                                hide-details
                                prepend-icon="description"
                                class="mb-3"
                                no-data-text="Registro não encontrado."
                                auto-select-first
                                @change="changeTipoItemProjeto"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field 
                                label="Editar Item Projeto"
                                :value="editItemProjeto.Item"
                                @change="v => editItemProjeto.Item = v"
                                prepend-icon="folder"
                                @keyup.enter="adicionaItemProjeto"
                                @keyup.esc="cancelaEditaItemProjeto(itemProjeto)" 
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                              <v-menu v-model="editPrevisaoInicialDatePicker">
                                <v-text-field slot="activator" 
                                  :value="moment(previsaoInicial).format('DD/MM/YYYY')" 
                                  label="Previsão Inicial" 
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker 
                                  locale="pt" 
                                  v-model="previsaoInicial" 
                                  @change="changePrevisaoInicialDatePicker"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs3>
                              <v-menu v-model="editPrevisaoFinalDatePicker">
                                <v-text-field slot="activator" 
                                  :value="moment(previsaoFinal).format('DD/MM/YYYY')" 
                                  label="Previsão Final" 
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker 
                                  locale="pt" 
                                  v-model="previsaoFinal" 
                                  @change="changePrevisaoFinalDatePicker"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field 
                                prepend-icon="access_time" 
                                mask="time" 
                                return-masked-value 
                                label="Duração" 
                                placeholder="00:00" 
                                v-model="duracao"
                                @keyup.enter="adicionaItemProjeto"
                              ></v-text-field>
                            </v-flex>
                            <v-flex class="text-xs-right">
                              <v-tooltip bottom>
                                <v-btn icon @click="cancelaEditaItemProjeto(itemProjeto)" slot="activator">
                                  <v-icon>close</v-icon>
                                </v-btn>
                                <span>Cancelar</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <v-btn 
                                  slot="activator" 
                                  icon color="primary"
                                  class="elevation-5"
                                  :loading="loadingItemProjeto"
                                  @click="adicionaItemProjeto" 
                                >
                                  <v-icon>done</v-icon>
                                </v-btn>
                                <span>Salvar</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>
                  <!-- Input ItemProjeto -->
                  <v-flex xs12 v-if="inputItemProjeto" class="border-form">
                    <v-layout row wrap align-center>
                      <v-flex xs2>
                        <v-text-field 
                          label="Classificação"
                          :value="itemProjeto.Classificacao"
                          @change="v => itemProjeto.Classificacao = v"
                          prepend-icon="folder"
                          id="itemProjeto-add-item"
                          @keyup.esc="inputItemProjeto = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-autocomplete
                          v-model="itemProjeto.Tipo"
                          :items="[{ IdTipo: 1, Descricao: 'GRUPO'}, { IdTipo: 2, Descricao: 'ITEM'} ]"
                          item-text="Descricao"
                          return-object
                          menu-props="auto"
                          label="Tipo"
                          hide-details
                          prepend-icon="description"
                          class="mb-3"
                          no-data-text="Registro não encontrado."
                          auto-select-first
                          @change="changeTipoItemProjeto"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field 
                          label="Item Projeto"
                          :value="itemProjeto.Item"
                          @change="v => itemProjeto.Item = v"
                          prepend-icon="folder"
                          @keyup.enter="adicionaItemProjeto"
                          @keyup.esc="inputItemProjeto = false"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <v-menu v-model="previsaoInicialDatePicker">
                          <v-text-field slot="activator" 
                            :value="moment(previsaoInicial).format('DD/MM/YYYY')" 
                            label="Previsão Inicial" 
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker 
                            locale="pt" 
                            v-model="previsaoInicial" 
                            @change="changePrevisaoInicialDatePicker"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3>
                        <v-menu v-model="previsaoFinalDatePicker">
                          <v-text-field slot="activator" 
                            :value="moment(previsaoFinal).format('DD/MM/YYYY')" 
                            label="Previsão Final" 
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker 
                            locale="pt" 
                            v-model="previsaoFinal" 
                            @change="changePrevisaoFinalDatePicker"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field 
                          prepend-icon="access_time" 
                          mask="time" 
                          return-masked-value 
                          label="Duração" 
                          placeholder="00:00" 
                          v-model="duracao"
                          @keyup.enter="adicionaItemProjeto"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="text-xs-right">
                        <v-tooltip bottom>
                          <v-btn icon @click="inputItemProjeto = false" slot="activator">
                            <v-icon>close</v-icon>
                          </v-btn>
                          <span>Cancelar</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <v-btn 
                            slot="activator" 
                            icon color="primary"
                            class="elevation-5"
                            :loading="loadingItemProjeto"
                            @click="adicionaItemProjeto" 
                          >
                            <v-icon>done</v-icon>
                          </v-btn>
                          <span>Salvar</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </div>
              </v-card-text>
              <PageLoading v-else />
            </v-card>
          </v-flex>
          <!-- Coluna Detalhes Projeto -->
          <v-flex v-if="showInfoColumn" xs12 md3 :class="{ 'pl-4': $vuetify.breakpoint.mdAndUp }">
            <v-card>
              <v-card-text>
                <v-autocomplete
                  :disabled="!permiteAlterar"
                  v-model="projeto.Responsavel"
                  :items="colaboradores"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Responsável"
                  hide-details
                  prepend-icon="person"
                  class="mb-3"
                  no-data-text="Registro não encontrado."
                  auto-select-first
                  @change="changeResponsavel"
                ></v-autocomplete>
                <v-autocomplete
                  :disabled="!permiteAlterar"
                  v-model="projeto.TipoProjeto"
                  :items="tiposProjeto"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Tipo Projeto"
                  hide-details
                  prepend-icon="label_important"
                  class="mb-3"
                  no-data-text="Registro não encontrado."
                  auto-select-first
                  @change="changeTipoProjeto"
                ></v-autocomplete>
                <v-autocomplete
                  :disabled="!permiteAlterar"
                  v-model="projeto.Situacao"
                  :items="situacoesProjeto"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Situação"
                  hide-details
                  prepend-icon="description"
                  class="mb-3"
                  no-data-text="Registro não encontrado."
                  auto-select-first
                  @change="changeSituacao"
                ></v-autocomplete>
                <v-autocomplete
                  :disabled="!permiteAlterar"
                  v-model="projetoTag.Descricao"
                  :items="tagsAtivo"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Tags"
                  hide-details
                  prepend-icon="label"
                  class="mb-3"
                  @change="changeTag"
                  no-data-text="Registro não encontrado."
                  auto-select-first
                ></v-autocomplete>
                <v-autocomplete
                  :disabled="!permiteAlterar"
                  v-model="projetoColaborador.Colaborador"
                  :items="colaboradores"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Colaboradores"
                  hide-details
                  prepend-icon="group_add"
                  class="mb-3"
                  @change="changeColaborador"
                  no-data-text="Registro não encontrado."
                  auto-select-first
                ></v-autocomplete>
                <v-autocomplete
                  :disabled="!permiteAlterar"
                  v-model="projeto.Fantasia"
                  :items="clientesAtivo"
                  item-text="Fantasia"
                  return-object
                  menu-props="auto"
                  label="Cliente"
                  hide-details
                  prepend-icon="group"
                  class="mb-3"
                  @change="changeClientes"
                  no-data-text="Registro não encontrado."
                  auto-select-first
                  clearable
                ></v-autocomplete>
                <v-menu
                  :disabled="!permiteAlterar"
                  v-model="projetoDatepicker"
                  :close-on-content-click="false"
                  full-width>
                  <v-text-field slot="activator"
                    :value="moment(dataPrevisao).format('DD/MM/YYYY')" label="Previsão" prepend-icon="event" :disabled="!permiteAlterar">
                  </v-text-field>
                  <v-date-picker locale="pt" v-model="dataPrevisao" @change="changeProjetoDatepicker"></v-date-picker>
                </v-menu>
                <v-text-field 
                  :disabled="!permiteAlterar"
                  prepend-icon="access_time" 
                  mask="time" 
                  return-masked-value 
                  label="Duração Limite" 
                  placeholder="00:00" 
                  v-model="duracaoLimite"
                ></v-text-field>
                <v-autocomplete
                :disabled="!permiteAlterar"
                v-model="projeto.IdGravidade"
                :items="gravidades"
                item-text="Gravidade"
                item-value="IdGravidade"
                menu-props="auto"
                label="Gravidade"
                hide-details
                prepend-icon="outlined_flag"
                class="mb-3"
                auto-select-first
                clearable
                no-data-text="Registro não encontrado."
              ></v-autocomplete>
              <v-autocomplete
                :disabled="!permiteAlterar"
                v-model="projeto.IdUrgencia"
                :items="urgencias"
                item-text="Urgencia"
                item-value="IdUrgencia"
                menu-props="auto"
                label="Urgência"
                hide-details
                prepend-icon="outlined_flag"
                class="mb-3"
                auto-select-first
                clearable
                no-data-text="Registro não encontrado."
              ></v-autocomplete>
              <v-autocomplete
                :disabled="!permiteAlterar"
                v-model="projeto.IdTendencia"
                :items="tendencias"
                item-text="Tendencia"
                item-value="IdTendencia"
                menu-props="auto"
                label="Tendência"
                hide-details
                prepend-icon="outlined_flag"
                class="mb-3"
                auto-select-first
                clearable
                no-data-text="Registro não encontrado."
              ></v-autocomplete>
              <v-autocomplete
                :disabled="!permiteAlterar"
                v-model="projeto.ValorNps"
                :items="valoresNps"
                menu-props="auto"
                label="NPS"
                hide-details
                prepend-icon="grade"
                class="mb-3"
                auto-select-first
                clearable
                no-data-text="Registro não encontrado."
              ></v-autocomplete>
                <!-- Resumo Duração Itens Projetos -->
                <v-card color="grey lighten-2 mb-3">
                  <v-card-text>
                    <p class="subheading mb-1">Duração Limite/Prevista/Realizada</p>
                    <v-icon class="mr-1">access_time</v-icon>
                    <span class="title">{{ duracaoItem(projeto.DuracaoLimite) }} / </span>
                    <span class="title">{{ totalDuracaoItensProjeto }} / </span>
                    <span class="title" :class="corDuracao">{{ totalDuracaoRealizadaItensProjeto }}</span>
                  </v-card-text>
                </v-card>
                <!-- Resumo Atividades Projeto -->
                <v-card color="grey lighten-2">
                  <v-card-text>
                    <div class="atividades-geral mb-3">
                      <p class="subheading mb-1">Atividades</p>
                      <span class="title">{{ qtdeAtividadesProjeto }}</span>
                    </div>
                    <div class="atividades-pendentes mb-3">
                      <p class="subheading mb-1">Atividades Pendentes</p>
                      <span class="title">{{ qtdeAtividadesProjetoPendentes }}</span>
                    </div>
                    <div class="atividades-Finalizadas mb-3">
                      <p class="subheading mb-1">Atividades Finalizadas</p>
                      <span class="title">{{ qtdeAtividadesProjetoFinalizadas }}</span>
                    </div>
                    <div class="atividades-canceladas">
                      <p class="subheading mb-1">Atividades Canceladas</p>
                      <span class="title">{{ qtdeAtividadesProjetoCanceladas }}</span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid px-3 slot="informacoes">
        <v-layout column>
          <v-flex xs12>
            <!-- Visão Geral -->
            <v-container grid-list-lg fluid pa-0>
              <v-layout column wrap>
                <v-flex>
                  <v-card>
                    <v-card-title class="py-0">
                      <h3>Objetivo</h3>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <v-btn icon slot="activator" @click="mostraInputObjetivo = !mostraInputObjetivo">
                          <v-icon>{{ iconInputObjetivo }}</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-if="!mostraInputObjetivo">
                      <div class="markdown-container prewrap" v-html="compileMarkdown(projeto.Objetivo)"></div>
                    </v-card-text>
                    <!-- Input Objetivo -->
                    <v-card-text v-else>
                      <SharedTextarea
                        :value="projeto.Objetivo"
                        @change="v => projeto.Objetivo = v"
                        label="Objetivo" 
                        hide-details
                        outline
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex>
                  <v-card>
                    <v-card-title class="py-0">
                      <h3>Escopo</h3>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <v-btn icon slot="activator" @click="mostraInputEscopo = !mostraInputEscopo">
                          <v-icon>{{ iconInputEscopo }}</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-if="!mostraInputEscopo">
                      <div class="markdown-container prewrap" v-html="compileMarkdown(projeto.Escopo)"></div>
                    </v-card-text>
                    <!-- Input Escopo -->
                    <v-card-text v-else>
                      <SharedTextarea
                        :value="projeto.Escopo"
                        @change="v => projeto.Escopo = v"
                        label="Escopo" 
                        hide-details
                        outline
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex>
                  <v-card>
                    <v-card-title class="py-0">
                      <h3>Requisito</h3>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <v-btn icon slot="activator" @click="mostraInputRequisito = !mostraInputRequisito">
                          <v-icon>{{ iconInputRequisito }}</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-if="!mostraInputRequisito">
                      <div class="markdown-container prewrap" v-html="compileMarkdown(projeto.Requisito)"></div>
                    </v-card-text>
                    <!-- Input Requisito -->
                    <v-card-text v-else>
                      <SharedTextarea
                        :value="projeto.Requisito"
                        @change="v => projeto.Requisito = v"
                        label="Requisito" 
                        hide-details
                        outline
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex>
                  <v-card>
                    <v-card-title class="py-0">
                      <h3>Risco</h3>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <v-btn icon slot="activator" @click="mostraInputRisco = !mostraInputRisco">
                          <v-icon>{{ iconInputRisco }}</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-if="!mostraInputRisco">
                      <div class="markdown-container prewrap" v-html="compileMarkdown(projeto.Risco)"></div>
                    </v-card-text>
                    <!-- Risco -->
                    <v-card-text v-else>
                      <SharedTextarea
                        :value="projeto.Risco"
                        @change="v => projeto.Risco = v"
                        label="Risco" 
                        hide-details
                        outline
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex>
                  <v-card>
                    <v-card-title class="py-0">
                      <h3>Responsabilidade</h3>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <v-btn icon slot="activator" @click="mostraInputResponsabilidade = !mostraInputResponsabilidade">
                          <v-icon>{{ iconInputResponsabilidade }}</v-icon>
                        </v-btn>
                        <span>Editar</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-if="!mostraInputResponsabilidade">
                      <div class="markdown-container prewrap" v-html="compileMarkdown(projeto.Responsabilidade)"></div>
                    </v-card-text>
                    <!-- Responsabilidade -->
                    <v-card-text v-else>
                      <SharedTextarea
                        :value="projeto.Responsabilidade"
                        @change="v => projeto.Responsabilidade = v"
                        label="Responsabilidade" 
                        hide-details
                        outline
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid px-3  slot="observacoes">
        <v-layout column>
          <v-flex xs12>
            <v-card>
              <v-card-title class="py-0">
                <h3>Observações</h3>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <v-btn icon flat slot="activator" @click="mostraInputObservacoes = !mostraInputObservacoes">
                    <v-icon>{{ iconInputObservacoes }}</v-icon>
                  </v-btn>
                  <span>Editar</span>
                </v-tooltip>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text v-if="!mostraInputObservacoes">
                <div class="markdown-container prewrap" v-html="compileMarkdown(projeto.Observacoes)"></div>
              </v-card-text>
              <!-- Observacoes -->
              <v-card-text v-else>
                <SharedTextarea
                  :value="projeto.Observacoes"
                  @change="v => projeto.Observacoes = v"
                  label="Observacoes" 
                  hide-details
                  outline
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <Grid
        slot="atividades"
        class="pt-1"
        :items="projetoAtividades"
        :searchTerm="searchTerm"
        :loading="searchLoading"
        :forcePagConfigDefault="false"
        :filtroAtivo="filtroAtivo"
      />
      <v-data-table
        slot="projetos"
        v-model="selected"
        :headers="headers"
        :items="projetoProjetos"
        item-key="IdProjeto"
        class="elevation-1 pt-1"
        rows-per-page-text="Registros"
        select-all
        :pagination.sync="defaultPagConfig"
        :loading="searchLoading"
        :search="searchTerm"
        no-data-text="Nenhum registro encontrado"
      >
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <tr
            :active="props.selected"
            class="cursor-pointer"
            @click="props.selected = !props.selected"
            @dblclick="abreModalInfoProjeto(props.item.IdProjeto)"
          >
            <td>
              <v-checkbox :input-value="props.selected" primary color="primary" hide-details></v-checkbox>
            </td>
            <td v-for="(header, index) in headers" :key="index">
              <v-avatar v-if="header.value === 'Status'" size="32" :color="statusCor(props.item.Status)">
                <span class="white--text">{{ props.item.Status[0] }}</span>
              </v-avatar>
              <v-chip v-if="header.value === 'Situacao'" dark :color="props.item.Cor">{{ props.item.Situacao }}</v-chip>
              <v-progress-circular
                v-if="header.value === 'ValorGut'"
                :size="36"
                :value="props.item.ValorGut || 0"
                :color="matrizGutColor(props.item.ValorGut || 0)"
              >
                <span class="font-weight-medium">{{ props.item.ValorGut || 0 }}</span>
              </v-progress-circular>
              <v-progress-circular
                v-if="header.value === 'ValorNps' && props.item.ValorNps !== null && props.item.ValorNps !== undefined"
                :size="36"
                :value="npsValue(props.item.ValorNps)"
                :color="npsColor(props.item.ValorNps)"
              >
                <span class="font-weight-medium">{{ props.item.ValorNps }}</span>
              </v-progress-circular>
              <span v-if="filtraHeaders(header)">{{ props.item[header.value] }}</span>
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >Pesquisa por "{{ searchTerm }}" não encontrou resultados.</v-alert>
        </template>
        <template v-slot:pageText="props">
          {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
      </v-data-table>
    </TabsProjeto>

    <!-- Modal Setar Previsão -->
    <ModalEditPrevisao 
      v-model="dialogPrevisao"
      :atividade="atividade"
      :loading="setaPrevisaoLoading"
      @setaPrevisaoSelected="setaPrevisaoItemSelected"
    />
    <!-- Modal Setar Situação -->
    <ModalEditSituacao 
      v-model="dialogSituacao"
      :atividade="atividade"
      :loading="setaSituacaoLoading"
      @setaSituacaoSelected="setaSituacaoItemSelected"
    />
    <!-- Modal Setar Responsável -->
    <ModalEditResponsavel 
      v-model="dialogResponsavel"
      :atividade="atividade"
      :loading="setaResponsavelLoading"
      @setaResponsavelSelected="setaResponsavelItemSelected"
    />
    <!-- Modal Setar Colaborador -->
    <ModalEditColaborador 
      v-model="dialogColaborador"
      :atividadeColaborador="atividadeColaborador"
      :loading="setaColaboradorLoading"
      @setaColaboradorSelected="setaColaboradorItemSelected"
    />
    <!-- Modal Setar Cliente -->
    <ModalEditCliente 
      v-model="dialogCliente"
      :atividadeCliente="atividadeCliente"
      :loading="setaClienteLoading"
      @setaClienteSelected="setaClienteItemSelected"
    />
    <!-- Modal Setar Tag -->
    <ModalEditTag 
      v-model="dialogTag"
      :atividadeTag="atividadeTag"
      :loading="setaTagLoading"
      @setaTagSelected="setaTagItemSelected"
    />
    <!-- Modal Atividade -->
    <ModalAtividade 
      v-model="dialogAtividade"
      :atividade="atividade"
      :loading=atividadeLoading
    />
    <!-- Modal Lista Atividades -->
    <ModalListAtividade 
      v-model="dialogListAtividade"
      :loading="buscaAtividadesLoading"
      @vinculaAtividade="vinculaAtividadeSelected"
      @atualizaListaAtividadesVincular="atualizaListaAtividadesVincular"
    />
    <!-- Modal Lista Projetos -->
    <ModalListProjeto 
      v-model="dialogListProjeto"
      :loading="buscaProjetosLoading"
      @vinculaProjeto="vinculaProjetoSelected"
      @atualizaListaProjetosVincular="atualizaListaProjetosVincular"
    />
    <!-- Modal Lista Clientes -->
    <ModalListClientes
      v-model="dialogListClientes"
      @vinculaClientes="vinculaClientesSelected"
    />
    <!-- Modal Setar Tipo Atividade -->
    <ModalEditTipoAtividade 
      v-model="dialogTipoAtividade"
      :atividade="atividade"
      :loading="setaTipoAtividadeLoading"
      @setaTipoAtividadeSelected="setaTipoAtividadeItemSelected"
    />
    <!-- Modal Setar Ocorrencia -->
    <ModalSetaOcorrencia 
      v-model="dialogOcorrencia"
      :loading="setaOcorrenciaLoading"
      :atividadeOcorrencia="atividadeOcorrencia"
      @setaOcorrenciaSelected="setaOcorrenciaItemSelected"
    />
    <!-- Modal Setar Workflow -->
    <ModalEditWorkflow 
      v-model="dialogWorkflow"
      :atividade="atividade"
      :loading="setaWorkflowLoading"
      @setaWorkflowSelected="setaWorkflowItemSelected"
    />
    <!-- Modal Cliente -->
    <ModalCadastroCliente 
      v-model="modalCliente"
      :cliente="cliente"
      :clienteEndereco="clienteEndereco"
      :clienteTelefone="clienteTelefone"
      :clienteEmail="clienteEmail"
      @clienteAdicionado="clienteAdicionado"
      @telefoneAdicionado="telefoneAdicionado"
      @emailAdicionado="emailAdicionado"
      @editaTelefone="editaTelefone"
      @editaEmail="editaEmail"
      @cancelaEditaTelefone="cancelaEditaTelefone"
      @cancelaEditaEmail="cancelaEditaEmail"
      @addNewEndereco="addNewEndereco"
      @deleteEndereco="deleteEndereco"
      @deleteTelefone="deleteTelefone"
      @deleteEmail="deleteEmail"
      @changeEndereco="changeEndereco"
    />
    <!-- Modal Modelo Atividade -->
    <ModalModeloAtividade
      v-model="modalModeloAtividade"
      @iniciaAtividadeModeloAtividade="iniciaAtividadeModeloAtividade"
    />
    <!-- Modal Preferencias Item Projeto -->
    <ModalPreferenciasItemProjeto
      v-model="modalPreferenciasItemProjeto"
      :itemProjeto="itemProjetoSelected"
      @itemProjetoPreferenciasAtualizado="itemProjetoPreferenciasAtualizado"
    />
    <!-- Modal Info Projeto -->
    <ModalInfoProjeto 
      v-model="modalInfoProjeto"
      :projeto="projetoInfo"
    />
  </div>
  <PageLoading v-else />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { matrizGutHelper } from '@/utils/matrizGutHelper';
import { npsHelper } from '@/utils/npsHelper';
import { projetoService } from '@/domain/projeto/ProjetoService';
import marked from 'marked';
import Projeto from '@/domain/projeto/Projeto';
import ProjetoColaborador from '@/domain/projeto/ProjetoColaborador';
import ProjetoTag from '@/domain/projeto/ProjetoTag';
import Atividade from '@/domain/atividade/Atividade';
import ItemProjeto from '@/domain/projeto/ItemProjeto';
import TabsProjeto from '@/components/projeto/TabsProjeto';
import Grid from "@/components/shared/Grid";
import AtividadeColaborador from '@/domain/atividade/AtividadeColaborador';
import AtividadeCliente from '@/domain/atividade/AtividadeCliente';
import AtividadeTag from '@/domain/atividade/AtividadeTag';
import ModalEditPrevisao from '@/components/atividade/ModalEditPrevisao';
import ModalEditSituacao from '@/components/atividade/ModalEditSituacao';
import ModalEditResponsavel from '@/components/atividade/ModalEditResponsavel';
import ModalEditColaborador from '@/components/atividade/ModalEditColaborador';
import ModalEditCliente from '@/components/atividade/ModalEditCliente';
import ModalEditTag from '@/components/atividade/ModalEditTag';
import ModalAtividade from '@/components/atividade/ModalAtividade';
import ModalListAtividade from '@/components/atividade/ModalListAtividade';
import ModalListProjeto from '@/components/projeto/ModalListProjeto';
import ModalListClientes from '@/components/atividade/ModalListClientes';
import ModalEditTipoAtividade from '@/components/atividade/ModalEditTipoAtividade';
import Cliente from '@/domain/cliente/Cliente';
import ClienteEndereco from '@/domain/cliente/ClienteEndereco';
import ClienteTelefone from '@/domain/cliente/ClienteTelefone';
import ClienteEmail from '@/domain/cliente/ClienteEmail';
import ModalCadastroCliente from '@/components/cliente/ModalCadastroCliente';
import ModalModeloAtividade from '@/components/atividade/ModalModeloAtividade';
import ModalPreferenciasItemProjeto from '@/components/projeto/ModalPreferenciasItemProjeto';
import ModalInfoProjeto from '@/components/projeto/ModalInfoProjeto';
import ModalEditWorkflow from '@/components/atividade/ModalEditWorkflow';
import ModalSetaOcorrencia from '@/components/atividade/ModalSetaOcorrencia';
import AtividadeOcorrencia from '@/domain/atividade/AtividadeOcorrencia';
import SharedTextarea from '@/components/shared/Textarea';

export default {
  name: 'CadastroProjeto',
  components: {
    TabsProjeto,
    Grid,
    ModalEditPrevisao,
    ModalEditSituacao,
    ModalEditResponsavel,
    ModalEditColaborador,
    ModalEditCliente,
    ModalEditTag,
    ModalAtividade,
    ModalListAtividade,
    ModalListClientes,
    ModalEditTipoAtividade,
    ModalCadastroCliente,
    ModalModeloAtividade,
    ModalPreferenciasItemProjeto,
    ModalListProjeto,
    ModalInfoProjeto,
    ModalSetaOcorrencia,
    ModalEditWorkflow,
    SharedTextarea,
  },
  data() {
    return {
      menu: false,
      menuAdicionarItem: true,
      menuAcoes: true,
      loadingPage: true,
      formTitle: 'Projeto',
      showInfoColumn: true,
      searchTerm: '',
      searchLoading: false,
      id: this.$route.params.id || null,
      projeto: new Projeto(),
      projetoColaborador: new ProjetoColaborador(),
      projetoTag: new ProjetoTag(),
      itensProjeto: [],
      projetoColaboradores: [],
      projetoTags: [],
      projetoProjetos: [],
      projetoAtividades: [],
      projetoOriginal: {},
      itemProjeto: new ItemProjeto(),
      itemProjetoOriginal: {},
      editItemProjeto: new ItemProjeto(),
      inputItemProjeto: false,
      editandoItemProjeto: false,
      previsaoInicial: new Date().toISOString().substr(0, 10),
      previsaoFinal: new Date().toISOString().substr(0, 10),
      previsaoInicialDatePicker: false,
      editPrevisaoInicialDatePicker: false,
      previsaoFinalDatePicker: false,
      editPrevisaoFinalDatePicker: false,
      loadingProjeto: false,
      loadingItemProjeto: false,
      duracao: '00:00',
      duracaoLimite: '00:00',
      classificacaoItemProjeto: '',
      valid: true,
      // Inputs informacoes e observacoes
      mostraInputObservacoes: false,
      mostraInputObjetivo: false,
      mostraInputEscopo: false,
      mostraInputRequisito: false,
      mostraInputRisco: false,
      mostraInputResponsabilidade: false,
      projetoDatepicker: false,
      dataPrevisao: new Date().toISOString().substr(0, 10),
      clienteInfo: null,
      filtroAtivo: 'Todas',
      // Modal
      atividade: new Atividade(),
      atividadeOcorrencia: new AtividadeOcorrencia(),
      atividadeColaborador: null,
      atividadeCliente: null,
      atividadeTag: null,
      dialogPrevisao: false,
      dialogSituacao: false,
      dialogResponsavel: false,
      dialogColaborador: false,
      dialogCliente: false,
      dialogTag: false,
      dialogAtividade: false,
      dialogListAtividade: false,
      dialogListClientes: false,
      dialogTipoAtividade: false,
      dialogOcorrencia: false,
      dialogWorkflow: false,
      dialogClientInfo: false,
      setaPrevisaoLoading: false,
      setaSituacaoLoading: false,
      setaResponsavelLoading: false,
      setaColaboradorLoading: false,
      setaClienteLoading: false,
      setaTagLoading: false,
      setaTipoAtividadeLoading: false,
      setaOcorrenciaLoading: false,
      setaWorkflowLoading: false,
      atividadeLoading: false,
      vinculaItemLoading: false,
      loadingInfoClient: false,
      buscaAtividadesLoading: false,
      // Modal Cliente
      loading: false,
      modalCliente: false,
      cliente: new Cliente(),
      clienteEndereco: new ClienteEndereco(),
      clienteTelefone: new ClienteTelefone(),
      clienteEmail: new ClienteEmail(),
      // Modal Modelo Atividade
      modalModeloAtividade: false,
      // Modal Preferencias Item Projeto
      modalPreferenciasItemProjeto: false,
      itemProjetoSelected: null,
      // Permite alterar
      permiteAlterar: true,
      // Modal List Projetos
      dialogListProjeto: false,
      buscaProjetosLoading: false,
      // Modal Info Projeto
      projetoInfo: new Projeto(),
      modalInfoProjeto: false,
      // Aba Projetos
      selected: [],
      headers: [
        { text: "ID", value: "IdProjeto" },
        { text: "Descrição", value: "Projeto" },
        { text: "Cliente", value: "Cliente" },
        { text: "Tipo", value: "TipoProjeto" },
        { text: "Responsável", value: "Responsavel" },
        { text: "Situação", value: "Situacao" },
        { text: "Status", value: "Status" },
        { text: "GUT", value: "ValorGut" },
        { text: "NPS", value: "ValorNps" },
      ],
      customHeaders: ["Status", "Situacao", "ValorGut", "ValorNps"],
      defaultPagConfig: {
        descending: false,
        page: 1,
        rowsPerPage: 10, // -1 for All"
        sortBy: "Descricao"
      },
      gravidades: [
        { IdGravidade: 1, Gravidade: 'SEM GRAVIDADE' },
        { IdGravidade: 2, Gravidade: 'POUCO GRAVE' },
        { IdGravidade: 3, Gravidade: 'GRAVE' },
        { IdGravidade: 4, Gravidade: 'MUITO GRAVE' },
        { IdGravidade: 5, Gravidade: 'EXTREMAMENTE GRAVE' }
      ],
      urgencias: [
        { IdUrgencia: 1, Urgencia: 'LONGO PRAZO' },
        { IdUrgencia: 2, Urgencia: 'BASTANTE PRAZO' },
        { IdUrgencia: 3, Urgencia: 'MÉDIO PRAZO' },
        { IdUrgencia: 4, Urgencia: 'CURTO PRAZO' },
        { IdUrgencia: 5, Urgencia: 'O QUANTO ANTES' }
      ],
      tendencias: [
        { IdTendencia: 1, Tendencia: 'NÃO PIORA' },
        { IdTendencia: 2, Tendencia: 'PIORA AO LONGO PRAZO' },
        { IdTendencia: 3, Tendencia: 'PIORA AO MÉDIO PRAZO' },
        { IdTendencia: 4, Tendencia: 'PIORA AO CURTO PRAZO' },
        { IdTendencia: 5, Tendencia: 'PIORA RAPIDAMENTE' }
      ],
      valoresNps: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    }
  },
  methods: {
    ...mapMutations(['showNotification', 'closeNotification']),
    ...mapActions([
      'resetProjetoState',
      'addProjeto',
      'updateProjeto',
      'fetchProjetoById',
      'fetchItensProjetosNode',
      // 'addItemProjeto',
      'updateItemProjeto',
      'deleteItemProjeto',
      'fetchAtividadesProjetoTodas',
      'fetchAtividadesProjeto',
      'fetchAtividadesVinculadasProjeto',
      'fetchAtividadesVinculos',
      'addAtividadeVinculo',
      'deleteAtividadeVinculo',
      'updateAtividade',
      'updateAtividadeNode',
      'deleteAtividadeNode', 
      'finalizarAtividadeNode',
      'voltarStatusAtividade',
      'resetAtividadesSelected',
      'addAtividadeColaborador',
      'addClienteAtividadeSelectedNode',
      'addAtividadeColaboradorNode',
      'fetchMinhasAtividadesNode',
      'fetchAtividadesParaVinculoNode',
      'fetchSituacoesProjeto',
      'fetchSituacoesAtividade',
      'fetchTiposProjeto',
      'fetchColaboradores',
      'fetchClientes',
      'fetchClienteById',
      'fetchProjetoColaboradores',
      'addProjetoColaborador',
      'deleteProjetoColaborador',
      'fetchTags',
      'fetchProjetoTags',
      'addProjetoTag',
      'addAtividadeTag',
      'deleteProjetoTag',
      'deleteClienteEndereco',
      'deleteClienteTelefone',
      'deleteClienteEmail',
      'fetchClienteEnderecos',
      'fetchClienteTelefones',
      'fetchClienteEmails',
      'fetchClienteTags',
      'fetchClienteProjetos',
      'fetchProjetosParaVinculo',
      'addProjetoVinculo',
      'addOcorrenciaNode',
      // 'fetchProjetosVinculo'
    ]),
    async abreModalInfoProjeto(idProjeto) {
      try {
        this.projetoInfo = await this.fetchProjetoById({ id: idProjeto });
        // await this.fetchItensProjetosNode(idProjeto);
        this.modalInfoProjeto = true;
      } catch (error) {
        this.showNotification({ text: `Ocorreu um erro ao buscar as informações do projeto: ${error}.`, status: 'error' });
      }
    },
    filtraHeaders(header) {
      return !this.customHeaders.includes(header.value);
    },

    npsValue(valor) {
      return npsHelper.npsValue(valor);
    },

    npsColor(valor) {
      return npsHelper.npsColor(valor);
    },

    matrizGutColor(valor) {
      return matrizGutHelper.matrizGutColor(valor);
    },

    statusCor(status) {
      if (status.startsWith('A')) return "#263238";
      if (status.startsWith('P')) return "#263238";
      if (status.startsWith('F')) return "#1976d2";
      if (status.startsWith('C')) return "#bdbdbd";
    },
    async itemProjetoPreferenciasAtualizado() {
      this.itemProjetoSelected = null;
      this.modalPreferenciasItemProjeto = false;
    },
    compileMarkdown(text) {
      return text ? marked(text) : '';
    },
    async changeResponsavel(obj) {
      this.projeto.Responsavel = obj.Descricao;
      this.projeto.IdResponsavel = obj.IdColaborador;
      if (!this.colaboradorJaInteressado(this.user) && obj.IdColaborador != this.user.IdColaborador) {
        if (confirm('Deseja ser adicionado como interessado desse projeto?')) {
          await this.changeColaborador(this.user);
        }
      }
    },
    changeTipoProjeto(obj) {
      this.projeto.TipoProjeto = obj.Descricao;
      this.projeto.IdTipoProjeto = obj.IdTipoProjeto;
    },
    changeTipoItemProjeto(obj) {
      if (this.editItemProjeto.IdProjeto) {
        this.editItemProjeto.Tipo = obj.Descricao;
        this.editItemProjeto.IdTipo = obj.IdTipo;
      } else {
        this.itemProjeto.Tipo = obj.Descricao;
        this.itemProjeto.IdTipo = obj.IdTipo;
      }
    },
    changeSituacao(obj) {
      this.projeto.Situacao = obj.Descricao;
      this.projeto.IdSituacao = obj.IdSituacao;
    },
    changeClientes(obj) {
      if (obj && typeof obj === 'object') {
        this.projeto.Fantasia = obj.Fantasia;
        this.projeto.IdCliente = obj.IdCliente;
      } else {
        this.projeto.Fantasia = '';
        this.projeto.IdCliente = undefined;
      }
    },
    changeProjetoDatepicker() {
      this.projetoDatepicker = false;
    },
    changeSituacaoItemProjeto(obj) {
      if (this.editItemProjeto.IdItem) {
        this.editItemProjeto.Situacao = obj.Descricao;
        this.editItemProjeto.IdSituacao = obj.IdSituacao;
      } else {
        this.itemProjeto.Situacao = obj.Descricao;
        this.itemProjeto.IdSituacao = obj.IdSituacao;
      }
    },
    close() {
      this.$router.go(-1);
      this.resetProjetoState();
    },
    async adicionaItemProjeto() {
      this.loadingItemProjeto = true;
      // Verifica se a duração é valida
      if (this.duracao.length < 5) {
        this.duracao = '00:00';
      }

      if (this.editItemProjeto.IdItem) {
        this.itemProjeto = this.editItemProjeto;
        this.itemProjeto.Classificacao = this.classificacaoItemProjeto;

        const minutoDuracao = `${this.duracao[3]}${this.duracao[4]}`;
        const horaDuracao = `${this.duracao[0]}${this.duracao[1]}`;
        this.itemProjeto.DuracaoPrevista = this.moment(new Date(1970, 0, 1, 0, 0, 0)).add(horaDuracao, 'h').add(minutoDuracao, 'm').toDate();
        const [anoInicial, mesInicial, diaInicial] = this.previsaoInicial.split('-');
        this.itemProjeto.PrevisaoInicial = new Date(anoInicial, mesInicial - 1, diaInicial);
        const [anoFinal, mesFinal, diaFinal] = this.previsaoFinal.split('-');
        this.itemProjeto.PrevisaoFinal = new Date(anoFinal, mesFinal - 1, diaFinal);

        const updItemProjeto = { ...this.itemProjeto };

        try {
          await projetoService.updateItemProjeto(updItemProjeto);
          this.editandoItemProjeto = null;
          this.itemProjetoOriginal = {};
          this.itemProjeto = new ItemProjeto();
          this.editItemProjeto = new ItemProjeto();
          this.duracao = '00:00';
          this.loadingItemProjeto = false;
          this.showNotification({ text: 'Item Projeto atualizado com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.loadingItemProjeto = false;
          this.showNotification({ text, status: 'error' });
        }
      } else {
        this.itemProjeto.IdProjeto = this.projeto.IdProjeto;
        const minutoDuracao = `${this.duracao[3]}${this.duracao[4]}`;
        const horaDuracao = `${this.duracao[0]}${this.duracao[1]}`;
        this.itemProjeto.DuracaoPrevista = this.moment(new Date(1970, 0, 1, 0, 0, 0)).add(horaDuracao, 'h').add(minutoDuracao, 'm').toDate();
        const [anoInicial, mesInicial, diaInicial] = this.previsaoInicial.split('-');
        this.itemProjeto.PrevisaoInicial = new Date(anoInicial, mesInicial - 1, diaInicial);
        const [anoFinal, mesFinal, diaFinal] = this.previsaoFinal.split('-');
        this.itemProjeto.PrevisaoFinal = new Date(anoFinal, mesFinal - 1, diaFinal);
        
        const newItemProjeto = { ...this.itemProjeto };

        try {
          const response = await projetoService.addItemProjeto(newItemProjeto);
          newItemProjeto.IdItem = response.data.IdItem;
          this.itensProjeto.push(newItemProjeto);
          this.itemProjeto = new ItemProjeto();
          this.duracao = '00:00';
          this.loadingItemProjeto = false;
          this.showNotification({ text: 'Item Projeto adicionado com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.loadingItemProjeto = false;
          this.showNotification({ text, status: 'error' });
        }
        const focusElement = document.getElementById('itemProjeto-add-item');
        this.$nextTick(() => {
          if (focusElement) focusElement.focus();
        });
      }
      await this.getItensProjeto();
    },
    abreModalIniciaAtividade(itemProjeto) {
      // Encontra o grupo com base na classificação do item que solicitou 
      // o início de atividade e pega as preferencias
      const { Preferencias: grupoPreferencias } = this.itensProjeto.find(item => item.Classificacao.startsWith(itemProjeto.Classificacao[0]));
      const { Preferencias: itemPreferencias } = itemProjeto;
      
      if (grupoPreferencias) {
        const { IdModeloAtividade } = JSON.parse(grupoPreferencias);
        itemProjeto.IdModeloAtividade = IdModeloAtividade;
      }

      if (itemPreferencias) {
        const { IdModeloAtividade } = JSON.parse(itemPreferencias);
        itemProjeto.IdModeloAtividade = IdModeloAtividade || itemProjeto.IdModeloAtividade;
      }

      if (itemProjeto.IdModeloAtividade) {
        this.iniciaAtividade(itemProjeto);
      } else {
        this.abreModalModeloAtividade(itemProjeto);
      }
    },
    async abreModalModeloAtividade(itemProjeto) {
      this.itemProjeto = Object.assign({}, itemProjeto);
      this.modalModeloAtividade = true;
    },
    iniciaAtividadeModeloAtividade(IdModeloAtividade) {
      this.itemProjeto.IdModeloAtividade = IdModeloAtividade;
      this.modalModeloAtividade = false;
      this.iniciaAtividade(this.itemProjeto);
    },
    async iniciaAtividade(itemProjeto) {
      if (confirm(`Tem certeza que deseja iniciar a atividade do item projeto: ${itemProjeto.Classificacao} ${itemProjeto.Item}`)) {
        this.vinculaItemLoading = true;
        itemProjeto.IdResponsavel = this.user.IdColaborador;
        itemProjeto.Responsavel = this.user.Colaborador;
        itemProjeto.Projeto = this.projeto.Projeto;
        try {
          await this.addAtividadeVinculo(itemProjeto);
          await this.getItensProjeto();
          this.buscaProjetoAtividades();
          this.itemProjeto = Object.assign({}, new ItemProjeto());
          this.vinculaItemLoading = false;
          this.showNotification({ text: 'Atividade iniciada com sucesso!', status: 'success' });
        } catch (error) {
          this.vinculaItemLoading = false;
          this.showNotification({ text: `Ocorreu um erro ao iniciar a atividade ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Operação cancelada', status: 'error' });
      }
    },
    mostraInputItemProjeto() {
      this.inputItemProjeto = true;
      this.$nextTick(() => document.getElementById('itemProjeto-add-item').focus());
    },
    editaItemProjeto(itemProjeto) {
      // Guarda uma cópia original do Item Projeto
      this.editandoItemProjeto = itemProjeto.IdItem;
      this.editItemProjeto = itemProjeto;
      // Resolver problema da reatividade do Vue.js pois a lista esta sendo ordenada pela classificação
      this.classificacaoItemProjeto = itemProjeto.Classificacao;
      this.itemProjetoOriginal = Object.assign({}, itemProjeto);
      this.previsaoInicial = new Date(itemProjeto.PrevisaoInicial).toISOString().substr(0, 10);
      this.previsaoFinal = new Date(itemProjeto.PrevisaoFinal).toISOString().substr(0, 10);
      this.duracao = this.duracaoItem(itemProjeto.DuracaoPrevista);
      this.$nextTick(() => document.getElementById('itemProjeto-edit-item').focus());
    },

    cancelaEditaItemProjeto(itemProjeto) {
      // Retorna o Item Projeto ao seu valor original antes da edição
      Object.assign(itemProjeto, this.itemProjetoOriginal);
      this.editandoItemProjeto = null;
      this.editItemProjeto = new ItemProjeto();
      this.previsaoInicial = new Date().toISOString().substr(0, 10);
      this.previsaoFinal = new Date().toISOString().substr(0, 10);
      this.duracao = '00:00';
      this.showNotification({ text: 'Operação cancelada.', status: 'error' });
    },
    editaItemDblClick(itemProjeto) {
      if (itemProjeto.Atividade) {
        this.$router.push({ name: 'altera atividade', params: { id: itemProjeto.Atividade.IdAtividade } })
      } else if (itemProjeto.Projeto) {
        this.abreModalInfoProjeto(itemProjeto.Projeto.IdProjeto);
      } else {
        if (!this.permiteAlterar) return false;
        this.editaItemProjeto(itemProjeto);
      }
    },
    async excluiItemProjeto(itemProjeto) {
      if (confirm(`Excluir: ${itemProjeto.Classificacao} ${itemProjeto.Item}?`)) {
        try {
          // await this.deleteItemProjeto(itemProjeto);
          await projetoService.deleteItemProjeto(itemProjeto);
          this.itensProjeto = this.itensProjeto.filter(i => i.IdItem !== itemProjeto.IdItem);
          this.buscaProjetoProjetos();
          this.buscaProjetoAtividades();
          this.loadingItemProjeto = false;
          this.showNotification({ text: `ItemProjeto: ${itemProjeto.Classificacao} ${itemProjeto.Item} excluído com sucesso.`, status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.loadingChecklist = false;
          this.showNotification({ text, status: 'error' });
        }
      }
    },
    changePrevisaoInicialDatePicker() {
      if (this.editPrevisaoInicialDatePicker) {
        this.editItemProjeto.PrevisaoInicial = this.previsaoInicial;
        this.editPrevisaoInicialDatePicker = false;
      } else {
        this.itemProjeto.PrevisaoInicial = this.previsaoInicial;
        this.ItemProjetoDatepicker = false;
      }
    },
    changePrevisaoFinalDatePicker() {
      if (this.editPrevisaoFinalDatePicker) {
        this.editItemProjeto.PrevisaoFinal = this.previsaoFinal;
        this.editPrevisaoFinalDatePicker = false;
      } else {
        this.itemProjeto.PrevisaoFinal = this.previsaoFinal;
        this.ItemProjetoDatepicker = false;
      }
    },
    searchAtividade(term) {
      this.searchTerm = term;
    },
    async refreshAtividadesProjeto() {
      this.searchLoading = true;
      await this.buscaProjetoAtividades();
      this.searchLoading = false;
    },
    // MODAL
    abreModalEditPrevisao(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogPrevisao = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogPrevisao = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a previsão.', status: 'error' });
      }
    },
    abreModalItemProjetoPreferencias(itemProjeto) {
      this.itemProjetoSelected = itemProjeto;
      this.modalPreferenciasItemProjeto = true;
    },
    abreModalEditSituacao(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogSituacao = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogSituacao = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a situação.', status: 'error' });
      }
    },
    abreModalEditResponsavel(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogResponsavel = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogResponsavel = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o responsável.', status: 'error' });
      }
    },
    abreModalEditTipoAtividade(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogTipoAtividade = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogTipoAtividade = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o tipo de atividade.', status: 'error' });
      }
    },
    abreModalEditWorkflow(atividade) {
      if (atividade !== null) {
        this.atividade = Object.assign({}, atividade);
        this.dialogWorkflow = true;
      } else if (this.atividadesSelected.length) {
        this.atividade = null;
        this.dialogWorkflow = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o workflow.', status: 'error' });
      }
    },
    abreModalSetaOcorrencia(atividade) {
      if (atividade !== null) {
        this.atividadeOcorrencia.IdAtividade = atividade.IdAtividade;
        this.dialogOcorrencia = true;
      } else if (this.atividadesSelected.length) {
        this.dialogOcorrencia = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a ocorrência.', status: 'error' });
      }
    },
    abreModalEditColaborador(atividade) {
      if (atividade !== null) {
        this.atividadeColaborador.IdAtividade = atividade.IdAtividade;
        this.dialogColaborador = true;
      } else if (this.atividadesSelected.length) {
        this.atividadeColaborador = null;
        this.dialogColaborador = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o colaborador.', status: 'error' });
      }
    },
    abreModalEditCliente(atividade) {
      if (atividade !== null) {
        this.atividadeCliente.IdAtividade = atividade.IdAtividade;
        this.dialogCliente = true;
      } else if (this.atividadesSelected.length) {
        this.atividadeCliente = null;
        this.dialogCliente = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o cliente.', status: 'error' });
      }
    },
    abreModalEditTag(atividade) {
      if (atividade !== null) {
        this.atividadeTag.IdAtividade = atividade.IdAtividade;
        this.dialogTag = true;
      } else if (this.atividadesSelected.length) {
        this.atividadeTag = null;
        this.dialogTag = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a tag.', status: 'error' });
      }
    },
    abreModalEditAtividade(atividade) {
      this.atividade = atividade;
      this.dialogAtividade = true;
    },
    async atualizaListaProjetosVincular() {
      this.buscaProjetosLoading = true;
      try {
        await this.fetchProjetosParaVinculo({ idProjeto: this.projeto.IdProjeto, idResponsavel: this.user.IdColaborador });
        this.buscaProjetosLoading = false;
      } catch (error) {
        this.buscaProjetosLoading = false;
        this.showNotification({ text: `Ocorreu um erro ao atualizar a lista de projetos vincular: ${error}`, status: 'error' });
      }
    },
    async abreModalListProjeto(itemProjeto) {
      this.itemProjeto = itemProjeto;
      this.dialogListProjeto = true;
      this.atualizaListaProjetosVincular();
    },
    async atualizaListaAtividadesVincular() {
      this.buscaAtividadesLoading = true;
      try {
        await this.fetchAtividadesParaVinculoNode({ status: ['P'], idProjeto: this.projeto.IdProjeto, idTipoProjeto: this.projeto.IdTipoProjeto });
        this.buscaAtividadesLoading = false;
      } catch (error) {
        this.buscaAtividadesLoading = false;
        this.showNotification({ text: `Ocorreu um erro ao atualizar a lista de atividades vincular: ${error}`, status: 'error' });
      }
    },
    async abreModalListAtividade(itemProjeto) {
      this.itemProjeto = itemProjeto;
      this.dialogListAtividade = true;
      this.atualizaListaAtividadesVincular();
    },
    abreModalListClientes(itemProjeto) {
      this.itemProjeto = itemProjeto;
      this.dialogListClientes = true;
    },
    async vinculaClientesSelected(clientes) {
      if (clientes.length) {
        if (confirm(`Tem certeza que deseja vincular: ${clientes.length} clientes, ao grupo: ${this.itemProjeto.Item}?`)) {
          this.vinculaItemLoading = true;
          this.dialogListClientes = false;
          // Cria novo item projeto do tipo 2 (ITEM)
          for (const cliente of clientes) {
            const newItemProjeto = new ItemProjeto();
            newItemProjeto.Classificacao = this.preencheClassificacaoItemProjetoAuto(this.itemProjeto.Classificacao) || this.itemProjeto.Classificacao;
            newItemProjeto.IdProjeto = this.projeto.IdProjeto;
            newItemProjeto.Item = cliente.Fantasia;
            newItemProjeto.IdTipo = 2;
            newItemProjeto.Tipo = 'ITEM';
            this.itemProjeto = newItemProjeto;
            await this.adicionaItemProjeto();
            // await this.addItemProjeto(newItemProjeto);
          }
          this.vinculaItemLoading = false;
          this.itemProjeto = new ItemProjeto();
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' }); 
        } else {
          this.showNotification({ text: 'Operação cancelada', status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione um ou mais clientes para vincular.', status: 'error' });
      }
    },
    editItemSelected() {
      if (this.atividadesSelected.length) {
        // this.searchTerm ? localStorage.setItem('searchTerm', this.searchTerm) : localStorage.setItem('searchTerm', '');
        // localStorage.setItem('pagConfig', JSON.stringify(this.pagConfig));
        let id = this.atividadesSelected[this.atividadesSelected.length - 1].IdAtividade;
        this.$router.push({ name: 'altera atividade', params: { id } });
        this.resetAtividadesSelected();
      } else {
        this.showNotification({ text: 'Selecione uma atividade para alterar.', status: 'error' });
      }
    },
    deleteItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja excluir: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.deleteAtividadeNode(item.IdAtividade)));
          Promise.all(promises)
            .then(() => this.resetAtividadesSelected());
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para excluir.', status: 'error' });
      }
    },
    finalizaItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja finalizar: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.finalizarAtividadeNode(item)));
          Promise.all(promises)
            .then(() => this.resetAtividadesSelected());
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para finalizar.', status: 'error' });
      }
    },
    voltaStatusItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja voltar o status de: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.voltarStatusAtividade(item.IdAtividade)));
          Promise.all(promises)
            .then(() => {
              this.resetAtividadesSelected();
              this.buscaProjetoAtividades();
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para voltar o status.', status: 'error' });
      }
    },
    setaPrevisaoItemSelected(previsao) {
      if (this.atividadesSelected.length) {
        this.setaPrevisaoLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.DataPrevisao = previsao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogPrevisao = false;
            this.resetAtividadesSelected();
            this.buscaProjetoAtividades();
            this.setaPrevisaoLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a previsão.`, status: 'error' });
      }
    },
    setaSituacaoItemSelected(situacao) {
      if (this.atividadesSelected.length) {
        this.setaSituacaoLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdSituacao = situacao.IdSituacao;
          atividade.Situacao = situacao.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogSituacao = false;
            this.resetAtividadesSelected();
            this.buscaProjetoAtividades();
            this.setaSituacaoLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a situação.`, status: 'error' });
      }
    },
    setaResponsavelItemSelected(responsavel) {
      if (this.atividadesSelected.length) {
        this.setaResponsavelLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdResponsavel = responsavel.IdColaborador;
          atividade.Responsavel = responsavel.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogResponsavel = false;
            this.resetAtividadesSelected();
            this.buscaProjetoAtividades();
            this.setaResponsavelLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o responsável.`, status: 'error' });
      }
    },
    setaTipoAtividadeItemSelected(tipoAtividade) {
      if (this.atividadesSelected.length) {
        this.setaTipoAtividadeLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdTipoAtividade = tipoAtividade.IdTipoAtividade;
          atividade.TipoAtividade = tipoAtividade.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogTipoAtividade = false;
            this.resetAtividadesSelected();
            this.buscaProjetoAtividades();
            this.setaTipoAtividadeLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o tipo.`, status: 'error' });
      }
    },
    async setaOcorrenciaItemSelected(ocorrencia) {
      if (this.atividadesSelected.length) {
        this.setaOcorrenciaLoading = true;

        for (const atividade of this.atividadesSelected) {
          ocorrencia.IdAtividade = atividade.IdAtividade;
          await this.addOcorrenciaNode(ocorrencia);
        }
        this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
        this.dialogOcorrencia = false;
        this.resetAtividadesSelected();
        this.atividadeOcorrencia = new AtividadeOcorrencia();
        this.setaOcorrenciaLoading = false;
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a ocorrência.`, status: 'error' });
      }
    },
    setaWorkflowItemSelected(workflow) {
      if (this.atividadesSelected.length) {
        this.setaWorkflowLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdWorkflow = workflow.IdWorkflow;
          atividade.Workflow = workflow.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogWorkflow = false;
            this.resetAtividadesSelected();
            this.buscaProjetoAtividades();
            this.setaWorkflowLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o workflow.`, status: 'error' });
      }
    },
    setaColaboradorItemSelected(colaborador) {
      if (this.atividadesSelected.length) {
        this.setaColaboradorLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeColaborador = new AtividadeColaborador();
          atividadeColaborador.IdAtividade = item.IdAtividade;
          atividadeColaborador.IdColaborador = colaborador.IdColaborador;
          atividadeColaborador.Colaborador = colaborador.Descricao;
          promises.push(this.addAtividadeColaboradorNode(atividadeColaborador));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogColaborador = false;
            this.resetAtividadesSelected();
            this.setaColaboradorLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o colaborador.`, status: 'error' });
      }
    },
    setaClienteItemSelected(cliente) {
      if (this.atividadesSelected.length) {
        this.setaClienteLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeCliente = new AtividadeCliente();
          atividadeCliente.IdAtividade = item.IdAtividade;
          atividadeCliente.IdCliente = cliente.IdCliente;
          atividadeCliente.Fantasia = cliente.Fantasia;
          promises.push(this.addClienteAtividadeSelectedNode(atividadeCliente));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogCliente = false;
            this.resetAtividadesSelected();
            this.buscaProjetoAtividades();
            this.setaClienteLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o cliente.`, status: 'error' });
      }
    },
    setaTagItemSelected(tag) {
      if (this.atividadesSelected.length) {
        this.setaTagLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeTag = new AtividadeTag();
          atividadeTag.IdAtividade = item.IdAtividade;
          atividadeTag.IdTag = tag.IdTag || null;
          atividadeTag.Descricao = tag.Descricao || tag;
          promises.push(this.addAtividadeTag(atividadeTag));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogTag = false;
            this.resetAtividadesSelected();
            this.buscaProjetoAtividades();
            this.setaTagLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a tag.`, status: 'error' });
      }
    },
    async vinculaProjetoSelected(payload) {
      if (payload.length && payload.length == 1 && this.itemProjeto && this.itemProjeto.IdTipo == 2) {
        if (confirm(`Tem certeza que deseja vincular o projeto: ${payload[0].Projeto} ao item projeto: ${this.itemProjeto.Classificacao} ${this.itemProjeto.Item}`)) {          
            this.itemProjeto.IdProjeto = payload[0].IdProjeto;
            this.itemProjeto.IdProjetoVinculo = this.projeto.IdProjeto;
            this.itemProjeto.Projeto = this.projeto.Projeto;
            this.vinculaItemLoading = true;
            try {
              // await this.addProjetoVinculo(this.itemProjeto);
              await projetoService.addProjetoVinculo(this.itemProjeto);
              this.buscaProjetoProjetos();
              this.getItensProjeto();
              this.dialogListProjeto = false;
              this.vinculaItemLoading = false;
              this.itemProjeto = new ItemProjeto();
              this.showNotification({ text: 'Projeto vinculado com sucesso.', status: 'success' });
            } catch (error) {
              const text = error.response.data.error;
              this.vinculaItemLoading = false;
              this.showNotification({ text, status: 'error' });
            }
          } else {
            this.showNotification({ text: 'Operação cancelada', status: 'error' });
          }
      } else if (payload.length && payload.length >= 1 && this.itemProjeto && this.itemProjeto.IdTipo == 1) {
        if (confirm(`Tem certeza que deseja vincular: ${payload.length} projetos, ao grupo: ${this.itemProjeto.Item}?`)) {
          this.vinculaItemLoading = true;
          this.dialogListProjeto = false;
          // Cria novo item projeto do tipo 2 (ITEM)
          for (const projeto of payload) {
            const newItemProjeto = new ItemProjeto();
            newItemProjeto.Classificacao = this.preencheClassificacaoItemProjetoAuto(this.itemProjeto.Classificacao) || this.itemProjeto.Classificacao;
            newItemProjeto.IdProjeto = this.projeto.IdProjeto;
            newItemProjeto.Item = projeto.Projeto;
            newItemProjeto.IdTipo = 2;
            newItemProjeto.Tipo = 'ITEM';
            // const itemProjetoAdicionado = await this.addItemProjeto(newItemProjeto);
            const response = await projetoService.addItemProjeto(newItemProjeto);
            const itemProjetoAdicionado = response.data;
            this.itensProjeto.push(itemProjetoAdicionado);
            this.itemProjeto = itemProjetoAdicionado;

            // Vincula a atividade ao item projeto
            this.itemProjeto.IdProjeto = projeto.IdProjeto;
            this.itemProjeto.IdProjetoVinculo = this.projeto.IdProjeto;
            this.itemProjeto.Projeto = this.projeto.Projeto;
            try {
              // await this.addProjetoVinculo(this.itemProjeto);
              await projetoService.addProjetoVinculo(this.itemProjeto);
              this.itemProjeto = new ItemProjeto();
            } catch (error) {
              const text = error.response.data.error;
              this.vinculaItemLoading = false;
              this.showNotification({ text, status: 'error' });
            }
          }
          this.itemProjeto = new ItemProjeto();
          this.getItensProjeto();
          this.buscaProjetoProjetos();
          this.vinculaItemLoading = false;
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' }); 
        } else {
          this.showNotification({ text: 'Operação cancelada', status: 'error' });
        }
      }
    },
    async vinculaAtividadeSelected() {
      if (this.atividadesSelected.length && this.atividadesSelected.length == 1 && this.itemProjeto && this.itemProjeto.IdTipo == 2) {
        if (confirm(`Tem certeza que deseja vincular a atividade: ${this.atividadesSelected[0].Descricao} ao item projeto: ${this.itemProjeto.Classificacao} ${this.itemProjeto.Item}`)) {          
          this.itemProjeto.IdAtividade = this.atividadesSelected[0].IdAtividade;
          this.itemProjeto.Projeto = this.projeto.Projeto;
          this.vinculaItemLoading = true;
          try {
            await this.addAtividadeVinculo(this.itemProjeto);
            this.showNotification({ text: `Atividade vinculada com sucesso.`, status: 'success' });
            this.dialogListAtividade = false;
            this.vinculaItemLoading = false;
            this.resetAtividadesSelected();
            this.itemProjeto = new ItemProjeto();
            this.getItensProjeto();
            await this.buscaProjetoAtividades();
          } catch (error) {
            this.vinculaItemLoading = false;
            this.showNotification({ text: `Ocorreu um erro ao vincular a atividade ${error}`, status: 'error' });
          }
        } else {
          this.showNotification({ text: 'Operação cancelada', status: 'error' });
        }
      } else if (this.atividadesSelected.length && !this.itemProjeto) {
        if (confirm(`Tem certeza que deseja vincular ${this.atividadesSelected.length} atividade(s) ao projeto: ${this.projeto.Projeto}`)) {
          this.vinculaItemLoading = true;

          let promises = [];

          this.atividadesSelected.forEach(atividade => {
            let atividadeVincular = {
              IdProjeto: this.projeto.IdProjeto,
              IdAtividade: atividade.IdAtividade,
              Projeto: this.projeto.Projeto
            }

            promises.push(this.addAtividadeVinculo(atividadeVincular));
          });

          Promise.all(promises)
            .then(async () => {
              await this.buscaProjetoAtividades();
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
              this.dialogListAtividade = false;
              this.itemProjeto = new ItemProjeto();
              this.resetAtividadesSelected();
              this.vinculaItemLoading = false;
            })
            .catch(error => {
              this.vinculaItemLoading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao vincular as atividades: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: 'Operação cancelada', status: 'error' });
        }
      } else if (this.atividadesSelected.length && this.atividadesSelected.length >= 1 && this.itemProjeto && this.itemProjeto.IdTipo == 1) {
        const atividades = [...this.atividadesSelected];
        if (confirm(`Tem certeza que deseja vincular: ${atividades.length} atividades, ao grupo: ${this.itemProjeto.Item}?`)) {
          this.vinculaItemLoading = true;
          this.dialogListAtividade = false;
          // Cria novo item projeto do tipo 2 (ITEM)
          for (const atividade of atividades) {
            const newItemProjeto = new ItemProjeto();
            newItemProjeto.Classificacao = this.preencheClassificacaoItemProjetoAuto(this.itemProjeto.Classificacao) || this.itemProjeto.Classificacao;
            newItemProjeto.IdProjeto = this.projeto.IdProjeto;
            newItemProjeto.Item = atividade.Descricao;
            newItemProjeto.IdTipo = 2;
            newItemProjeto.Tipo = 'ITEM';
            // const itemProjetoAdicionado = await this.addItemProjeto(newItemProjeto);
            const response = await projetoService.addItemProjeto(newItemProjeto);
            const itemProjetoAdicionado = response.data;
            this.itensProjeto.push(itemProjetoAdicionado);
            this.itemProjeto = itemProjetoAdicionado;

            // Vincula a atividade ao item projeto
            this.itemProjeto.IdAtividade = atividade.IdAtividade;
            this.itemProjeto.Projeto = this.projeto.Projeto;
            try {
              await this.addAtividadeVinculo(this.itemProjeto);
              this.itemProjeto = new ItemProjeto();
            } catch (error) {
              this.vinculaItemLoading = false;
              this.showNotification({ text: `Ocorreu um erro ao vincular a atividade ${error}`, status: 'error' });
            }
          }
          this.itemProjeto = new ItemProjeto();
          this.resetAtividadesSelected();
          this.getItensProjeto();
          await this.buscaProjetoAtividades();
          this.vinculaItemLoading = false;
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' }); 
        } else {
          this.showNotification({ text: 'Operação cancelada', status: 'error' });
        }
      } else {
        this.showNotification({ text: `Selecione apenas uma atividade para vincular ao item projeto.`, status: 'error' });
      }
    },
    removerVinculoAtividade() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja remover o vínculo de ${this.atividadesSelected.length} atividades?`)) {
          let promises = [];
    
          this.atividadesSelected.forEach(atividade => {
            const atividadeVinculo = {
              IdProjeto: this.projeto.IdProjeto,
              IdAtividade: atividade.IdAtividade,
              Projeto: this.projeto.Projeto
            }
            promises.push(this.deleteAtividadeVinculo(atividadeVinculo));
          });
    
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
              this.resetAtividadesSelected();
              this.buscaProjetoAtividades();
            })
            .catch(error => {
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao remover o vinculo da atividade: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: 'Operação cancelada', status: 'error' });
        }
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para remover o vinculo do projeto.`, status: 'error' });
      }
    },
    duracaoItem(tempo) {
      // Verifica se o ano da tempo é 1899 == ano padrão DELPHI
      // Caso não, estaremos usando o ano padrão JavaScript == 1970
      const anoDelphi = new Date(tempo).getFullYear() == 1899;
      let inicio = anoDelphi ? this.moment([1899, 11, 30]) : new Date(1970, 0, 1, 0, 0, 0);
      // console.log('Inicio:', inicio.format('DD/MM/YYYY HH:mm'));
      let final = tempo ? this.moment(tempo) : this.moment(new Date(1970, 0, 1, 0, 0, 0));
      // console.log('Final:', final.format('DD/MM/YYYY HH:mm'));
      // Pega a diferença entre as datas em millisegundos
      let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
      let duration = this.moment.duration(ms);
      let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
      if (duracaoFinal.length === 4) duracaoFinal = `0${duracaoFinal}`;
      return duracaoFinal;
    },
    statusProjeto(status) {
      status = status.trim()
      if (status == 'A') return '#263238';
      if (status == 'F') return '#1976d2';
      if (status == 'C') return '#bdbdbd';
    },
    async changeColaborador(obj) {
      if (obj !== null && typeof obj == 'object') {
        this.projetoColaborador.IdProjeto = this.projeto.IdProjeto;
        this.projetoColaborador.Colaborador = obj.Descricao;
        this.projetoColaborador.IdColaborador = obj.IdColaborador;

        try {
          await projetoService.addProjetoColaborador(this.projetoColaborador);
          this.projetoColaboradores.push(this.projetoColaborador);
          this.projetoColaborador = new ProjetoColaborador();
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' })
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' })
        }

        // await this.addProjetoColaborador(this.projetoColaborador);
      }
    },

    async excluiColaborador(colaborador) {
      if (confirm(`Remover: ${colaborador.Colaborador}?`)) {
        try {
          await projetoService.deleteProjetoColaborador(colaborador);
          this.projetoColaboradores = this.projetoColaboradores.filter(c => c.IdColaborador !== colaborador.IdColaborador);
          this.showNotification({ text: 'Colaborador removido com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      }
    },

    async changeTag(obj) {
      if (obj !== null) {
        this.projetoTag.IdProjeto = this.projeto.IdProjeto;
        this.projetoTag.Descricao = obj.Descricao;
        this.projetoTag.IdTag = obj.IdTag;

        try {
          await projetoService.addProjetoTag(this.projetoTag);
          this.projetoTags.push(this.projetoTag);
          this.projetoTag = new ProjetoTag();
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' })
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' })
        }

        // await this.addProjetoTag(this.projetoTag);
        // this.projetoTag = new ProjetoTag();
      }
    },

    async excluiTag(tag) {
      if (confirm(`Remover: ${tag.Descricao}?`)) {
        try {
          await projetoService.deleteProjetoTag(tag);
          this.projetoTags = this.projetoTags.filter(t => t.IdTag !== tag.IdTag);
          this.showNotification({ text: 'Tag removida com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      }
    },

    corDuracaoItemProjeto(prevista, realizada) {
      if (this.moment(prevista).isSame(realizada)) return '';
      if (this.moment(prevista).isBefore(realizada)) return 'error--text';
      if (this.moment(prevista).isAfter(realizada)) return 'success--text';
    },
    // FIM MODAL
    // Buscas Atividades
    filtraAtividades(payload) {
      this.filtroAtivo = payload;
      this.buscaProjetoAtividades();
    },
    salvaConfigPesquisa() {
      localStorage.setItem('showInfoColumn', this.showInfoColumn);
      localStorage.setItem('filtroAtivoCadastroProjeto', this.filtroAtivo);
    },
    recuperaConfigPesquisa() {
      if (localStorage.getItem('showInfoColumn')) this.showInfoColumn = JSON.parse(localStorage.getItem('showInfoColumn'));
      if (localStorage.getItem('filtroAtivoCadastroProjeto')) {
        this.filtroAtivo = localStorage.getItem('filtroAtivoCadastroProjeto');
      } else {
        this.filtroAtivo = 'Todas';
      }
    },
    async buscaProjetoColaboradores() {
      try {
        const response = await projetoService.getProjetoColaboradores(this.id);
        this.projetoColaboradores = response.data;
      } catch (error) {
        const text = error.response.data.error;
        this.showNotification({ text, status: 'error' });
      }
    },
    async buscaProjetoTags() {
      try {
        const response = await projetoService.getProjetoTags(this.id);
        this.projetoTags = response.data;
      } catch (error) {
        const text = error.response.data.error;
        this.showNotification({ text, status: 'error' });
      }
    },
    async buscaProjetoProjetos() {
      try {
        const response = await projetoService.getProjetoProjetosVinculos(this.id);
        this.projetoProjetos = response.data;
      } catch (error) {
        const text = error.response.data.error;
        this.showNotification({ text, status: 'error' });
      }
    },
    async buscaProjetoAtividades() {
      try {
        const response = await projetoService.getProjetoAtividades(this.id, this.filtroAtivo);
        this.projetoAtividades = response.data;
      } catch (error) {
        const text = error.response.data.error;
        this.showNotification({ text, status: 'error' });
      }
    },
    async save() {
      this.loadingProjeto = true;
      if (!this.permiteAlterar) { 
        this.resetProjetoState();
        return this.$router.go(-1);
      }

      // Verifica se a duração é valida
      if (this.duracaoLimite.length < 5) {
        this.duracaoLimite = '00:00';
      }
      
      const minutoDuracaoLimite = `${this.duracaoLimite[3]}${this.duracaoLimite[4]}`;
      const horaDuracaoLimite = `${this.duracaoLimite[0]}${this.duracaoLimite[1]}`;
      this.projeto.DuracaoLimite = this.moment(new Date(1970, 0, 1, 0, 0, 0)).add(horaDuracaoLimite, 'h').add(minutoDuracaoLimite, 'm').toDate();
      const [ano, mes, dia] = this.dataPrevisao.split('-');
      this.projeto.DataPrevisao = new Date(ano, mes - 1, dia);
      if (this.id) {
        try {
          await this.updateProjeto(this.projeto);
          this.loadingProjeto = false;
          this.$router.go(-1);
          this.salvaConfigPesquisa();
          this.showNotification({ text: `Projeto: ${this.projeto.Projeto} atualizado com sucesso.`, status: 'success' });
          this.resetProjetoState();
        } catch (error) {
          this.loadingProjeto = false;
          this.showNotification({ text: `Não foi possível atualizar o projeto. ${error}`, status: 'error' });
        }
      }
    },

    // Modal Cliente

    addNewEndereco() {
      this.clienteEndereco = Object.assign({}, new ClienteEndereco());
    },
    async deleteEmail(email) {
      if (confirm(`Desejar remover o email: ${email.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteEmail(email);
          this.loading = false;
          this.clienteEmail = Object.assign({}, new ClienteEmail());
          this.showNotification({ text: 'E-mail excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o e-mail: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async deleteTelefone(telefone) {
      if (confirm(`Desejar remover o telefone: ${telefone.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteTelefone(telefone);
          this.loading = false;
          this.clienteTelefone = Object.assign({}, new ClienteTelefone());
          this.showNotification({ text: 'Telefone excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o telefone: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async deleteEndereco() {
      if (this.clienteEndereco.IdCliente && this.clienteEndereco.IdItem && confirm(`Desejar excluir o endereço: ${this.clienteEndereco.Titulo}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteEndereco(this.clienteEndereco);
          this.loading = false;
          this.clienteEndereco = Object.assign({}, new ClienteEndereco());
          this.showNotification({ text: 'Endereço excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o endereço atual: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    changeEndereco(endereco) {
      this.clienteEndereco = Object.assign({}, endereco);
    },
    clienteAdicionado() {
      this.clienteInfo = Object.assign({}, new Cliente());
    },
    telefoneAdicionado() {
      this.clienteTelefone = Object.assign({}, new ClienteTelefone());
    },
    emailAdicionado() {
      this.clienteEmail = Object.assign({}, new ClienteEmail());
    },
    editaEmail(email) {
      this.clienteEmail = Object.assign({}, email);
      if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('G')) {
        this.clienteEmail.Tipo = 'GERAL';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('N')) {
        this.clienteEmail.Tipo = 'NFE';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('F')) {
        this.clienteEmail.Tipo = 'FINANCEIRO';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('C')) {
        this.clienteEmail.Tipo = 'COMERCIAL';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('O')) {
        this.clienteEmail.Tipo = 'OUTROS';
      } else {
        this.clienteEmail.Tipo = 'GERAL';
      }
    },
    cancelaEditaEmail() {
      this.clienteEmail = Object.assign({}, new ClienteEmail());
    },
    editaTelefone(telefone) {
      this.clienteTelefone = Object.assign({}, telefone);
      if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('G')) {
        this.clienteTelefone.TipoTelefone = 'GERAL';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('R')) {
        this.clienteTelefone.TipoTelefone = 'RESIDENCIAL';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('C')) {
        this.clienteTelefone.TipoTelefone = 'CELULAR';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('T')) {
        this.clienteTelefone.TipoTelefone = 'TRABALHO';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('W')) {
        this.clienteTelefone.TipoTelefone = 'WHATSAPP';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('O')) {
        this.clienteTelefone.TipoTelefone = 'OUTROS';
      } else {
        this.clienteTelefone.TipoTelefone = 'GERAL';
      }
    },
    cancelaEditaTelefone() {
      this.clienteTelefone = Object.assign({}, new ClienteTelefone());
    },
    async infoClient(cliente) {
      try {
        this.cliente = await this.fetchClienteById(cliente);
        this.modalCliente = true;
        const endereco = await this.fetchClienteEnderecos(cliente);
        this.clienteEndereco = Object.assign({}, endereco);
        await this.fetchClienteTelefones(cliente);
        await this.fetchClienteEmails(cliente);
        await this.fetchClienteTags(cliente);
        await this.fetchClienteProjetos(cliente);
      } catch (error) {
        this.showNotification({ text: `Ocorreu um erro ao buscar as informações do cliente: ${error}.`, status: 'error' });
      }
    },
    // verifica se o usuário logado pode alterar o projeto
    // caso ele seja responsável, interessado ou admin
    usuarioTemPermissaoParaAlterar() {
      const ehResponsavel = this.user.IdColaborador === this.projeto.IdResponsavel;
      const ehInteressado = this.projetoColaboradores.find(colaborador => this.user.IdColaborador === colaborador.IdColaborador) || false;
      if (ehResponsavel || ehInteressado || this.isAdmin) {
        return true;
      } else {
        return false;
      }
    },
    colaboradorJaInteressado(colaborador) {
      const colaboradorJaAdicionado = this.projetoColaboradores.find(projetoColaborador => projetoColaborador.IdColaborador === colaborador.IdColaborador);
      return colaboradorJaAdicionado ? true : false;
    },
    preencheClassificacaoItemProjetoAuto(grupo) {
      // itens começando com o grupo informado
      const itensGrupo = this.itensProjeto.filter(item => item.Classificacao.startsWith(grupo));
      // Ultima classificacao do grupo
      let classificacao = itensGrupo[itensGrupo.length - 1].Classificacao;
      if (classificacao.length === 3) {
        return (Number(itensGrupo[itensGrupo.length - 1].Classificacao) + 0.1).toFixed(1);
      } else {
        return (Number(itensGrupo[itensGrupo.length - 1].Classificacao) + 0.01).toFixed(2);
      }
    },
    async getItensProjeto() {
      try {
        const response = await projetoService.getItensProjeto(this.id);
        this.itensProjeto = response.data;
      } catch (error) {
        const text = error.response.data.error;
        this.showNotification({ text, status: 'error' });
      }
    },
    async getAndInitializeProjeto() {
      try {
        const response = await projetoService.getProjeto(this.id);
        this.projeto = response.data[0];
        this.dataPrevisao = new Date(this.projeto.DataPrevisao).toISOString().substr(0, 10);
        this.duracaoLimite = this.duracaoItem(this.projeto.DuracaoLimite);

        await this.buscaProjetoColaboradores();
        
        this.permiteAlterar = this.usuarioTemPermissaoParaAlterar();

        await this.getItensProjeto();

        this.loadingPage = false;
      } catch (error) {
        const text = error.response.data.error;
        this.$router.go(-1);
        this.showNotification({ text, status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isAdmin',
      'rules',
      // 'itensProjetos', 
      // 'atividadesProjeto', 
      'atividadesVinculos', 
      'colaboradores', 
      'tagsAtivo',
      'tiposProjeto', 
      'situacoesProjeto', 
      'situacoesAtividade',
      'atividadesSelected',
      'clientesAtivo',
      // 'projetoColaboradores',
      // 'projetoTags',
      // 'projetosVinculo'
    ]),
    iconInputObjetivo() {
      return this.mostraInputObjetivo ? 'done' : 'edit';
    },
    iconInputEscopo() {
      return this.mostraInputEscopo ? 'done' : 'edit';
    },
    iconInputRequisito() {
      return this.mostraInputRequisito ? 'done' : 'edit';
    },
    iconInputRisco() {
      return this.mostraInputRisco ? 'done' : 'edit';
    },
    iconInputResponsabilidade() {
      return this.mostraInputResponsabilidade ? 'done' : 'edit';
    },
    iconInputObservacoes() {
      return this.mostraInputObservacoes ? 'done' : 'edit';
    },
    itensProjetoOrdenado() {
      return this.itensProjeto.sort((a,b) => a.Classificacao - b.Classificacao);
    },
    qtdeAtividadesProjeto() {
      return this.projetoAtividades.length;
    },
    qtdeAtividadesProjetoPendentes() {
      return this.projetoAtividades.filter(atividade => atividade.Status.trim() === 'P').length;
    },
    qtdeAtividadesProjetoFinalizadas() {
      return this.projetoAtividades.filter(atividade => atividade.Status.trim() === 'F').length;
    },
    qtdeAtividadesProjetoCanceladas() {
      return this.projetoAtividades.filter(atividade => atividade.Status.trim() === 'C').length;
    },
    totalDuracaoItensProjeto() {
      // let inicio = this.moment([1899, 11, 30]);
      let inicio = new Date(1970, 0, 1, 0, 0, 0);
      let duracoes = [];
      this.itensProjeto
        .filter(item => item.IdTipo == 2)
        .filter(item1 => item1.DuracaoPrevista !== null)
        .map(item2 => {
          // const duracao = this.moment(item2.DuracaoPrevista).format('HH:mm');
          const duracao = this.duracaoItem(item2.DuracaoPrevista);
          duracoes.push(duracao);
        });

      const duracoesTotal = duracoes.slice(1)
        .reduce((prev, cur) => this.moment.duration(cur).add(prev),
          this.moment.duration(duracoes[0]));

      let final = this.moment(inicio).add(duracoesTotal);
      let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
      let duration = this.moment.duration(ms);
      let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
      return duracaoFinal;
    },
    totalDuracaoRealizadaItensProjeto() {
      let inicio = new Date(1970, 0, 1, 0, 0, 0);
      let duracoes = [];
      this.projetoAtividades
        .filter(item => item.Duracao !== null)
        .map(item2 => {
          // const duracao = this.moment(item2.Duracao).format('HH:mm');
          const duracao = this.duracaoItem(item2.Duracao);
          duracoes.push(duracao);
        });

      const duracoesTotal = duracoes.slice(1)
        .reduce((prev, cur) => this.moment.duration(cur).add(prev),
          this.moment.duration(duracoes[0]));

      let final = this.moment(inicio).add(duracoesTotal);
      let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
      let duration = this.moment.duration(ms);
      let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
      return duracaoFinal;
    },
    corDuracao() {
      const [horaPrevista, minutoPrevisto] = this.totalDuracaoItensProjeto.split(':');
      const [horaRealizada, minutoRealizado] = this.totalDuracaoRealizadaItensProjeto.split(':');
      if (Number(horaRealizada) > Number(horaPrevista)) {
        return 'error--text';
      } else if (Number(horaRealizada) >= Number(horaPrevista) && Number(minutoRealizado) > Number(minutoPrevisto)) {
        return 'error--text';
      } else if (horaRealizada == '0' && minutoRealizado == '00') {
        return '';
      } else {
        return 'success--text';
      }
    },
    inputActive() {
      return this.inputItemProjeto ? 'blurred' : '';
    },
  },
  async created() {
    this.recuperaConfigPesquisa();

    if (this.id) {
      await this.getAndInitializeProjeto();
      this.buscaProjetoTags();
      this.buscaProjetoProjetos();
      this.buscaProjetoAtividades();
      // SELECT FIELDS
      this.fetchSituacoesProjeto();
      this.fetchSituacoesAtividade();
      this.fetchTiposProjeto();
      this.fetchColaboradores();
      this.fetchTags();
      this.fetchClientes();
    }
  },
  destroyed() {
    this.resetProjetoState();
  }
}
</script>

<style scoped>
  .projeto-detalhes {
    display: flex;
    flex-wrap: wrap;
  }
  .align-content-center {
    display: flex;
    align-items: center;
  }
  .prewrap {
    white-space: pre-wrap;
  }
  .border-form {
    padding: 10px;
    border: 2px solid #1976d2;
    border-radius: 4px;
  }
  .blurred {
    opacity: .5;
  }
  .cardscroll {
    max-height: 63rem;
    overflow-y: auto;
  }
  .tb > :first-child {
    padding-left: 16px;
  }
</style>